/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Nav_AffiliateInputs */

const en_seller_nav_affiliate = /** @type {(inputs: Seller_Nav_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affiliate`)
};

const es_seller_nav_affiliate = /** @type {(inputs: Seller_Nav_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afiliados`)
};

const fr_seller_nav_affiliate = /** @type {(inputs: Seller_Nav_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affiliation`)
};

const de_seller_nav_affiliate = /** @type {(inputs: Seller_Nav_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affiliate`)
};

const ja_seller_nav_affiliate = /** @type {(inputs: Seller_Nav_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アフィリエイト`)
};

const zh_seller_nav_affiliate = /** @type {(inputs: Seller_Nav_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推广计划`)
};

const ar_seller_nav_affiliate = /** @type {(inputs: Seller_Nav_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`برنامج التسويق (Affiliate)`)
};

const id_seller_nav_affiliate = /** @type {(inputs: Seller_Nav_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afiliasi`)
};

const it_seller_nav_affiliate = /** @type {(inputs: Seller_Nav_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affiliati`)
};

const ru_seller_nav_affiliate = /** @type {(inputs: Seller_Nav_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Партнерам`)
};

const pt_seller_nav_affiliate = /** @type {(inputs: Seller_Nav_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afiliados`)
};

const ko_seller_nav_affiliate = /** @type {(inputs: Seller_Nav_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어필리에이트`)
};

/**
* | output |
* | --- |
* | "Affiliate" |
*
* @param {Seller_Nav_AffiliateInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_nav_affiliate = /** @type {((inputs?: Seller_Nav_AffiliateInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Nav_AffiliateInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_nav_affiliate(inputs)
	if (locale === "es") return es_seller_nav_affiliate(inputs)
	if (locale === "fr") return fr_seller_nav_affiliate(inputs)
	if (locale === "de") return de_seller_nav_affiliate(inputs)
	if (locale === "ja") return ja_seller_nav_affiliate(inputs)
	if (locale === "zh") return zh_seller_nav_affiliate(inputs)
	if (locale === "ar") return ar_seller_nav_affiliate(inputs)
	if (locale === "id") return id_seller_nav_affiliate(inputs)
	if (locale === "it") return it_seller_nav_affiliate(inputs)
	if (locale === "ru") return ru_seller_nav_affiliate(inputs)
	if (locale === "pt") return pt_seller_nav_affiliate(inputs)
	return ko_seller_nav_affiliate(inputs)
});